"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlags = void 0;
class FeatureFlags {
    constructor(preferenceHttpAdapter) {
        this.preferenceHttpAdapter = preferenceHttpAdapter;
    }
    fetchFeatureFlags(platform) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const fetchedFeatureFlags = yield this.preferenceHttpAdapter.getFeatureFlags('smartorganisms');
                const featureFlag = fetchedFeatureFlags.find((featureFlag) => featureFlag.name == platform + '-smartorganisms-user-preferences');
                return Boolean(featureFlag === null || featureFlag === void 0 ? void 0 : featureFlag.enabled);
            }
            catch (error) {
                return false; //Calling API when Feature Flag service fails
            }
        });
    }
}
exports.FeatureFlags = FeatureFlags;
//# sourceMappingURL=feature-flags.js.map